@if (data && data.length) {
  <ul>
    @for (item of data; track item) {
      <li>
        <a target="_blank" [href]="item.path"
          [attr.data-test-id]="'sidebar-events-link-' + (item?.path | slugify)">
          <p>
            {{item.fieldEventMainDate | date:"dd.MM.yyyy"}}
            @if (item.fieldEventStartTimeMain) {
              kell {{item.fieldEventStartTimeMain | unixToTime}}
            }
          </p>
          <span>{{item.title}}</span>
        </a>
      </li>
    }
  </ul>
}
@if (data.length > 0) {
  <div class="bottom">
    <a routerLink="{{ '/sündmused' | translatePath }}"
      data-test-id="sidebar-events-view-all-link"
      >{{ 'button.view_all' | translate }}</a
      >
    </div>
  }
